module.exports = __webpack_public_path__ + "img/exclamation-point@2x.10c13c3c.png";